import React from "react";
import { CONTRACT_DICTIONARY } from "consts";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const ContractAutoSuggest = (props) => {
    const suggestContract = (q) => {
        if (q) {
            q = q.toLocaleLowerCase();
        }

        return Promise.resolve(
            Object
                .keys(CONTRACT_DICTIONARY)
                .filter(key => (CONTRACT_DICTIONARY[key] || "")
                    .toLocaleLowerCase()
                    .includes(q)
                )
        );
    };

    return (
        <AutoSuggest
            label="Contract type"
            fetchOptions={suggestContract}
            renderOption={(key) => ({label: `${CONTRACT_DICTIONARY[key]}`, value: key})}
            optionIdentifier={(value) => value}
            {...props}
        />
    );
};

export default ContractAutoSuggest;
